module.exports = __webpack_public_path__ + "static/img/1.60c121f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/sp/1.png
// module id = uq15
// module chunks = 0